export const getConfigDetails = () => {
    //  switch ('prestage') {
//    switch ('staging') {
    // switch ('preprod') {
        switch ('live') {
        case 'prestage': //staging2
            return {
                instance_baseURL: 'https://pre-stage-api.parkengage.com',
                config_baseURL: 'https://pre-stage-api.parkengage.com',
                // clientSecret: 'oO3kDjRzeOkU0wrNaSjss5yaa',
                clientSecret: 'ChMEibSZ8JGN8dnlVl8gvvz2S',
                adminBaseUrl: 'https://pre-stage.parkengage.com/',
                cmsBaseUrl: 'https://pre-stage.parkengage.com/',
            }
        case 'staging': //staging
            return {
                instance_baseURL: 'https://staging-api.parkengage.com',
                config_baseURL: 'https://staging-api.parkengage.com',
                clientSecret: 'ChMEibSZ8JGN8dnlVl8gvvz2S',
                adminBaseUrl: 'https://staging-admin.parkengage.com',
                cmsBaseUrl: 'https://staging.parkengage.com',
            }
        case 'preprod': //preprod
            return {
                instance_baseURL: 'https://preprod-api.parkengage.com',
                config_baseURL: 'https://preprod-api.parkengage.com',
                clientSecret: 'oO3kDjRzeOkU0wrNaSjss5yaa',
                adminBaseUrl: 'https://partner.parkengage.com',
                cmsBaseUrl: 'https://parkengage.com'
            }    
        case 'live': //live
            return {
                instance_baseURL: 'https://api.parkengage.com',
                config_baseURL: 'https://api.parkengage.com',
                clientSecret: 'oO3kDjRzeOkU0wrNaSjss5yaa',
                adminBaseUrl: 'https://preprod-admin.parkengage.com/',
                cmsBaseUrl: 'https://preprod.parkengage.com/'
            }
        
        
        case 'test': // Test
            return {
                instance_baseURL: 'https://test-api.parkengage.com',
                config_baseURL: 'https://test-api.parkengage.com',
                clientSecret: 'ChMEibSZ8JGN8dnlVl8gvvz2S',
                adminBaseUrl: 'https://test-admin.parkengage.com',
                cmsBaseUrl: 'https://test.parkengage.com',
            }
        default:
            return {
                instance_baseURL: 'https://staging-api.parkengage.com',
                config_baseURL: 'https://staging-api.parkengage.com',
                clientSecret: 'ChMEibSZ8JGN8dnlVl8gvvz2S',
                adminBaseUrl: 'https://staging-admin.parkengage.com',
                cmsBaseUrl: 'https://staging.parkengage.com',
            }    
    }
}
